import { Card } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'
import { VideoIcon } from 'lucide-react'

export const LocationRemote = () => {
	const { t } = useLingui()

	return (
		<Card
			variant='outline'
			className='flex items-center gap-4 p-4'
		>
			<VideoIcon className='!size-6' />

			<div>
				<div className='text-sm font-bold'>{t`Visio-conférence uniquement`}</div>

				<div className='text-muted-foreground text-xs'>
					{t`Aucune localisation, tout se passe à distance.`}
				</div>
			</div>
		</Card>
	)
}
